<template>
  <div class="summary white-box position-relative">
    <TileLoader :loading="loading"/>
    <div class="header-container">
      <h2>Statistiques</h2>
      <select :value="period.id"
              @change="updatePeriod($event.target.value)"
              class="period-select"
      >
        <option
          v-for="p of filteredPeriods"
          :value="p.id"
          :key="p.id"
        >
          à {{ formatPeriodHeader(p) }} {{ p.year }}
        </option>
      </select>
    </div>

    <div class="bar-container">
      <div class="bar">
        <div class="filled-bar" :style="{width: (percentNbFrsStatN + '%')}"></div>
        {{ nbFrsStatN }} / {{ nbFrsStatN1 }} ({{ percentNbFrsStatN }} %)
      </div>
    </div>

    <div class="d-flex justify-content-between mt-4 gap-2">
      <div>
        <div class="numbers">
          <p>CA Staté : {{ formatEuro(caStatN) }}</p>
          <p>Evolution par rapport à {{ formatPeriodHeader(period) }} {{ period.year - 1 }} :
            {{ percentProgressionStatN }} % <span class="indicator">(périmètre constant)</span></p>
        </div>
        <div class="perimeter">
          Etude réalisée sur {{ nbFrsStatN }} fournisseurs soit {{ percentDeclarationYearlyCA }} % du CA (calculé sur
          base
          de l'annuelle {{ baseYear }})
        </div>
      </div>
      <div>
        <a target="_blank"
           rel="noreferrer"
           :href="getDroneRedirectUrl('reports/6-2-4')"
        >
          <button class="btn-cmem">
            Voir le rapport
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import {getStatsRecap} from "@/utils/dashboardCdm";
import TileLoader from "./TileLoader.vue";
import dayjs from "dayjs";
import store from "@/store/dashboards";
import {getDroneRedirectUrl} from "@/helpers/getRedirectUrlHelper";

export default {
  components: {
    TileLoader
  },
  props: ["period", "detailedPeriods"],
  data() {
    return {
      loading: true,
      statsBySupplier: [],
      store
    }
  },
  mounted() {
    this.initData()
  },
  watch: {
    period() {
      this.initData();
    },
    storeGlobalView() {
      this.initData();
    }
  },
  methods: {
    getDroneRedirectUrl,
    updatePeriod(newPeriodId) {
      let newPeriod = this.detailedPeriods.find(dp => dp.id == newPeriodId);

      if (newPeriod)
        this.$emit('period-change', newPeriod);
    },
    initData() {
      if (!this.period || !this.period.id) return;
      this.loading = true;

      getStatsRecap(this.period.id, this.storeGlobalView).then(res => {
        this.statsBySupplier = res;
        this.loading = false;
      })
    },
    formatPeriodHeader(period) {
      let labelsPerMonth = {
        1: "fin janvier",
        2: "fin février",
        3: "fin mars",
        4: "fin avril",
        5: "fin mai",
        6: "fin juin",
        7: "fin juillet",
        8: "fin août",
        9: "fin septembre",
        10: "fin octobre",
        11: "fin novembre",
        12: "fin décembre"
      };

      let month = period.month;
      return labelsPerMonth[month];
    },
    formatEuro(value) {
      return Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(value);
    }
  },
  computed: {
    storeGlobalView() {
      return this.store.globalView;
    },
    filteredPeriods() {
      if (!this.detailedPeriods || !this.period) return [];
      let refDate = dayjs();

      let year = refDate.year();
      let month = refDate.month() + 1;

      let refScore = year * 12 + month;

      return this.detailedPeriods.filter(dp => dp.declarationType == 1 && (dp.year * 12 + dp.month) >= refScore - 12 && dp.year * 12 + dp.month <= refScore);
    },
    nbFrsStatN() {
      return this.statsBySupplier.filter(s => s.CaN).length;
    },
    nbFrsStatN1() {
      return this.statsBySupplier.filter(s => s.CaN1 || s.CaN).length;
    },
    percentNbFrsStatN() {
      if (!this.nbFrsStatN1) return 0;
      return Math.round(this.nbFrsStatN / this.nbFrsStatN1 * 100);
    },
    caStatN() {
      return this.statsBySupplier.reduce((acc, cur) => acc + cur.CaN, 0);
    },
    caStatNPerimetreConstant() {
      return this.statsBySupplier.reduce((acc, cur) => {
        if (cur.CaN && cur.CaN1)
          return acc + cur.CaN
        return acc;
      }, 0);
    },
    caStatN1PerimetreConstant() {
      return this.statsBySupplier.reduce((acc, cur) => {
        if (cur.CaN && cur.CaN1)
          return acc + cur.CaN1
        return acc;
      }, 0);
    },
    percentProgressionStatN() {
      if (!this.caStatN1PerimetreConstant) return 0;
      return Math.round((this.caStatNPerimetreConstant - this.caStatN1PerimetreConstant) / this.caStatN1PerimetreConstant * 100);
    },
    baseYear() {
      if (this.statsBySupplier.length == 0 || !this.statsBySupplier[0].BaseYear) return 0;
      return this.statsBySupplier[0].BaseYear;
    },
    baseYearCa() {
      if (this.statsBySupplier.length == 0 || !this.statsBySupplier[0].BaseYearCa) return 0;
      return this.statsBySupplier[0].BaseYearCa;
    },
    percentDeclarationYearlyCA() {
      // Vérification CA dernière déclaration annuelle existe
      if (!this.baseYearCa) return 0;

      // CA de la dernière déclaration annuelle des fournisseurs avec stats N
      let yearlyCaFournisseursStats = this.statsBySupplier.reduce((acc, cur) => {
        if (cur.CaN)
          return acc + cur.CaYear;
        return acc;
      }, 0)

      return Math.round(yearlyCaFournisseursStats / this.baseYearCa * 100);
    }
  }
}

</script>

<style scoped>

.white-box {
  flex: 1 1 30em;
}

.header-container {
  display: flex;
  column-gap: 6px;
}

h2 {
  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

.bar-container {
  margin-top: 12px;
  width: max(280px, 100%);
}

.bar-container .bar {
  position: relative;
  height: 24px;
  width: 100%;
  background-color: #E5E5E5;
  border-radius: 3px;
  overflow: hidden;
  z-index: 1;

  text-align: center;
}

.bar-container .bar .filled-bar {
  position: absolute;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(90.37deg, #A7C13C 0.06%, #7BD276 99.94%);
  z-index: -1;
}

.numbers {
  display: flex;
  flex-direction: column;
}

.numbers p {
  margin: 0;
}

.numbers .indicator {
  font-size: 0.8em;
  color: #777;
}

.perimeter {
  margin-top: 12px;
  font-size: 0.9em;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboards/StatsRecapTile.vue